export type FolderItem = {
  folderId: string;
  carrierId?: string;
  clientId: string;
  direction: string;
  tractorVrn: string;
  trailerVrn: string;
  clientName: string;
  crossingDate: string;
  folderNumber: string;
  folderStatusId: string;
  trailerLoadMode: string;
  folderTypologyId: string;
  crossingHourRangeId: string;
  bookingTransportReference: string;
  internalClientReference?: string;
  requiresSpsFormalities?: boolean;
  borderCrossingServiceId?: string;
};

export type GetFoldersResponse = {
  '@odata.context': string;
  '@odata.count': number;
  value: FolderItem[];
};

export type ResponseData = {
  folders: FolderItem[];
  foldersCount: number;
};

export type PaginationParams = {
  page: number;
  pageSize: number;
};

export enum FIELD_NAMES_TO_ORDER {
  CROSSING_DATE = 'crossingDate',
}

export enum ORDER_TYPE {
  ASC = 'asc',
  DESC = 'desc',
}

export type OrderBy = { by: string; type: ORDER_TYPE };
